/*
 * @Author: liuyongjun
 * @Date: 2023-01-29 13:33:13
 * @LastEditors: liuyongjun
 * @LastEditTime: 2023-01-30 13:20:44
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: \ejx-web\src\router\module\flight-normal-analysis-map.js
 */
const flightNormalAnalysis = r =>
  require.ensure([], () =>
    r(require('@/views/flight-normal-analysis/flight-normal-analysis.vue'), 'flightNormalAnalysis')
  )
const router = [
  {
    path: '/flightNormalAnalysis',
    name: 'flightNormalAnalysis',
    meta: {
      title: '航班动态'
    },
    component: flightNormalAnalysis
  }
]

export default router
